var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLines(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 338,
    height: 16,
    viewBox: "0 0 338 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 0C0.89543 0 0 0.89543 0 2C0 3.10457 0.89543 4 2 4V2V0ZM2 2V4H338V2V0H2V2Z",
    fill: "#017B93"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M72 12C70.8954 12 70 12.8954 70 14C70 15.1046 70.8954 16 72 16V14V12ZM72 14V16H338V14V12H72V14Z",
    fill: "#017B93"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLines);
export default __webpack_public_path__ + "static/media/lines.b6f778222c43259d302ae0fda1fe9b9a.svg";
export { ForwardRef as ReactComponent };